<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mrppvJ/tc-custom/9781459202894.jpg?1743836923229" alt="This image is the cover for the book Claiming His Wife, Latin Lovers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Claiming His Wife, Latin Lovers
      </h1>
      <p class="bookDescription body article font2">
        <p>Overwhelmed by her sexy, brand-new Spanish husband, Cassie had let anxiety and inexperience ruin first her wedding night, then her marriage to Roman Fernandez.<br/><br/>Now, after a year apart, Cassie has gained self-confidence. But her brother's in serious trouble with Roman, and Cassie returns to Spain to confront him. She soon realizes with a shiver of...<i>excitement?</i>...that her husband has every intention of claiming his wife and testing her newfound confidencein the bedroom....</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Diana Hamilton
      </h2>
      
      <p class="authorDescription body article">Diana Hamilton&rsquo;s first stories were written for the amusement of her children. They were never publihed, but the writing bug had bitten. Over the next ten years she combined writing novels with bringing up her children, gardening and cooking for the restaurant of a local inn &ndash; a wonderful excuse to avoid housework! In 1987 Diana realized her dearest ambition &ndash; the publication of her first Mills &amp; Boon romance. Diana lives in Shropshire, England, with her husband.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b3e721da